import React, { useEffect, useState } from "react";
import { getScheduleStopsByTripIdWithCities } from "../../../actions/home.action";
import * as XLSX from 'xlsx';
import { Button } from "antd";
import { DownloadOutlined } from '@ant-design/icons';


export const ExportScheduleToExcel = (props) =>{

    let {
        scheduleId
    } = props;

    const [scheduleStops, setScheduleStops] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        getScheduleStopsByTripIdWithCities(scheduleId,null,[],(data)=>{
            setScheduleStops(data);
        },(error)=>{
            console.log({error});
        })
    },[scheduleId])

    const exportToExcel = () => {
        if (!scheduleStops || !scheduleStops || !scheduleStops.citiesWithStops) {
            console.error("No data available to export");
            return;
        }

        setLoading(true);

        try {
            const citiesWithStops = scheduleStops.citiesWithStops;
            
            // Prepare data for Excel
            const excelData = [];
            
            citiesWithStops.forEach((city) => {
                // Add city header row
                excelData.push({
                    'City': city.displayName,
                    'Stop Name': '',
                    'Timing': city.timing,
                    'Day': city.day+1,
                    'Is Boarding': city.isBoarding ? 'Yes' : 'No',
                    'Is Drop': city.isDrop ? 'Yes' : 'No',
                    'Phone Number': '',
                    'Landline Number': '',
                    'Trip Close Point': city.tripClosePoint
                });
                
                // Add stops for this city
                if (city.stops && city.stops.length > 0) {
                    city.stops.forEach((stop) => {
                        excelData.push({
                            'City': '',
                            'Stop Name': stop.displayName,
                            'Timing': stop.timing,
                            'Day': stop.day+1,
                            'Is Boarding': stop.isBoarding ? 'Yes' : 'No',
                            'Is Drop': stop.isDrop ? 'Yes' : 'No',
                            'Phone Number': '',
                            'Landline Number': '',
                            'Trip Close Point': stop.tripClosePoint
                        });
                    });
                }
                
                // Add empty row for spacing between cities
                excelData.push({
                    'City': '',
                    'Stop Name': '',
                    'Timing': '',
                    'Day': '',
                    'Is Boarding': '',
                    'Is Drop': '',
                    'Phone Number': '',
                    'Landline Number': '',
                    'Trip Close Point': ''
                });
            });

            // Create workbook and worksheet
            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Schedule Stops');

            // Set column widths
            worksheet['!cols'] = [
                { wch: 30 }, // City
                { wch: 35 }, // Stop Name
                { wch: 12 }, // Timing
                { wch: 8 },  // Day
                { wch: 12 }, // Is Boarding
                { wch: 12 }, // Is Drop
                { wch: 15 }, // Phone Number
                { wch: 15 }, // Landline Number
                { wch: 15 }  // Trip Close Point
            ];

            // Generate filename with timestamp
            const timestamp = new Date().toISOString().slice(0, 10);
            const filename = `Schedule_Stops_${scheduleId}_${timestamp}.xlsx`;

            // Download the file
            XLSX.writeFile(workbook, filename);
            
            setLoading(false);
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            setLoading(false);
        }
    };

    
    return(
        <div>
            <Button 
                type="primary" 
                icon={<DownloadOutlined />}
                onClick={exportToExcel}
                loading={loading}
                disabled={!scheduleStops}
            >
                Export to Excel
            </Button>
        </div>
    )
}